import { motion } from "framer-motion";

const groups = [
  { name: "JP Aggarwal Group", note: "Steel · Present" },
  { name: "YP Singhania Group", note: "Cement · JK" },
  { name: "Aditya Birla Group", note: "Cement · UltraTech" },
  { name: "Binani Group", note: "Cement" },
];

export default function TrustedGroups() {
  return (
    <section aria-label="Groups served" className="relative border-b border-surface-2 bg-ink">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-16 md:py-20">
        <div className="grid grid-cols-12 items-center gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-3 text-[10px] uppercase tracking-[0.3em] text-brass">
            Practice built inside<br/>four industrial groups
          </div>
          <div className="col-span-12 md:col-span-9">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-surface-2">
              {groups.map((g, i) => (
                <motion.div
                  key={g.name}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  className="bg-ink px-6 md:px-8 py-8 flex flex-col justify-between min-h-[130px] group"
                >
                  <span className="tabular text-[10px] text-brass tracking-[0.3em]">
                    0{i + 1}
                  </span>
                  <div>
                    <div className="font-serif-display text-ivory text-lg md:text-xl leading-tight transition-colors duration-500 group-hover:text-brass">
                      {g.name}
                    </div>
                    <div className="mt-2 text-[10px] uppercase tracking-[0.22em] text-mutedfg">
                      {g.note}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
